import React, { useEffect, useState } from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { useLocation } from "react-router-dom";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import routes from "../../routes/routes";
import { convertirFecha } from "utils/generalFunctions";
import { useSelector } from "react-redux";
import { avantSolarApi } from "api/authApi";
import Alert from "components/alert";
import DataTableAvantSolar from "components/datatable/datatable";
import { obtenerNombreHuertaId } from "utils/generalFunctions";
import Footer from "components/Footer/Footer";
var ps;

function LecturasContador(props) {
  const mainPanel = React.useRef();
  const location = useLocation();
  const [contadores, setContadores] = useState([]);
  const [contadoresCopy, setContadoresCopy] = useState([]);
  const { jwt } = useSelector((state) => state.auth);
  const { huerta } = useSelector((state) => state.dataApp);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [datos, setDatos] = useState({
    fecha_inicial: "202301",
    fecha_final: "202304",
  });

  React.useEffect(() => {
    ps = new PerfectScrollbar(mainPanel.current);
    document.body.classList.toggle("perfect-scrollbar-on");

    return function cleanup() {
      ps.destroy();
      document.body.classList.toggle("perfect-scrollbar-on");
    };
  });

  const fetchInstalaciones = async (consulta) => {
    setError(null);
    setLoading(true);
    try {
      const response = await avantSolarApi.get(
        "/admins/meterReading?id_huerta=" + huerta + consulta,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + jwt,
          },
        }
      );

      let data = response.data;

      setLoading(false);
      if (data?.code == 200) {
        setContadores([...data.data]);
        setContadoresCopy([...data.data]);
      } else {
        setError(data.message);
      }
    } catch (error) {
      setError(error.response.data.message);
    }
  };

  useEffect(() => {
    const { fecha_final, fecha_inicial } = datos;
    let consulta = `&fecha_inicial=${fecha_inicial}&fecha_final=${fecha_final}`;
    fetchInstalaciones(consulta);
  }, [huerta]);

  React.useEffect(() => {
    mainPanel.current.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [location]);

  let est = 0.95;

  const handleSubmitForm = (event) => {
    event.preventDefault();
    let mesInicial = event.target.mesInicial.value.replace("-", "");
    let mesFinal = event.target.mesFinal.value.replace("-", "");
    let consulta = `&fecha_inicial=${mesInicial}&fecha_final=${mesFinal}`;
    let objeto = {
      fecha_inicial: mesInicial,
      fecha_final: mesFinal,
    };
    setDatos(objeto);
    fetchInstalaciones(consulta);
  };

  const obtenerAnioMesActual = (input = false) => {
    //El parámetro input sirve para devolverlo en formato para hacer la consulta o para ponerlo de defaultvalue en el input
    let fecha = new Date();
    let anio = fecha.getFullYear();
    let mes = fecha.getMonth() + 1;
    if (mes < 10) mes = "0" + mes;

    if (input == false) return anio + mes;
    return anio + "-" + mes;
  };

  const headers = [
    [
      "Instalacion",
      "Titular",
      `${contadores[0]?.fechaInicial} (KWH)`,
      `${contadores[0]?.fechaFinal} (KWH)`,
      "Diferencia (KWH)",
    ],
  ];

  const headersTable = [
    { name: "Instalación", prop: "numInstalacion" },
    { name: "Titular", prop: "titular" },
    {
      name: `${contadores[0]?.fechaInicial} (KWH)`,
      prop: "lecturaInicial",
    },
    {
      name: `${contadores[0]?.fechaFinal} (KWH)`,
      prop: "lecturaFinal",
    },
    { name: "Diferencia", prop: "diferencia" },
  ];

  const properties = [
    "numInstalacion",
    "titular",
    "lecturaInicial",
    "lecturaFinal",
    "diferencia",
  ];

  return (
    <div className="wrapper">
      <Sidebar {...props} routes={routes} />
      <div className="main-panel" ref={mainPanel}>
        <div>
          <DemoNavbar {...props} />
          <div>
            <form
              onSubmit={handleSubmitForm}
              className="d-flex  justify-content-center flex-column flex-sm-row"
            >
              <label className="d-flex justify-content-center align-items-center">
                Fecha Inicial:{" "}
                <input
                  name="mesInicial"
                  defaultValue={"2023-01"}
                  className="ml-1 mr-1"
                  type="month"
                  min={0}
                  max={11}
                />
              </label>
              <label className="d-flex justify-content-center align-items-center">
                Fecha Final:{" "}
                <input
                  name="mesFinal"
                  defaultValue={"2023-04"}
                  className="ml-1 mr-1"
                  type="month"
                  min={0}
                  max={11}
                />
                <button className="btn btn-primary btn-noPadding">
                  Enviar
                </button>
              </label>
            </form>
          </div>
          {!error && (
            <DataTableAvantSolar
              data={contadores}
              dataCopy={contadoresCopy}
              setData={setContadores}
              titleProps={
                "Lecturas de Contadores - Huerta: " +
                obtenerNombreHuertaId(huerta)
              }
              headers={headers}
              headersTable={headersTable}
              name={"lecturasContador"}
              properties={properties}
              filtros={["numInstalacion", "titular"]}
              placeholderInput={"Filtra por Titular o Instalación"}
              defaultMostrar={40}
              loading={loading}
            ></DataTableAvantSolar>
          )}

          {error && <Alert message={error} />}
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default LecturasContador;
